import React from 'react';
import { BoxProps, Button, HStack } from '@chakra-ui/react';

interface FaqPickerProps extends BoxProps {
  picked: string;
  setPicked: (label: string) => void;
}

export const FaqPicker: React.FC<FaqPickerProps> = ({ picked, setPicked }) => {
  return (
    <HStack
      spacing={2}
      bg="grey.200"
      px="8px"
      py="4px"
      borderRadius="12px"
      justifyContent="center"
      mb="12px"
    >
      <Button
        color="text.100"
        bg={picked === 'card' ? 'white' : 'none'}
        boxShadow={
          picked === 'card'
            ? '0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04)'
            : 'none'
        }
        _hover={{ bg: 'white' }}
        fontSize="12px"
        fontWeight={400}
        onClick={() => setPicked('card')}
        h="30px"
      >
        Visualização na busca
      </Button>

      <Button
        color="text.300"
        bg={picked === 'html' ? 'white' : 'none'}
        boxShadow={
          picked === 'html'
            ? '0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04)'
            : 'none'
        }
        fontSize="12px"
        fontWeight={400}
        _hover={{ bg: 'white' }}
        onClick={() => setPicked('html')}
        h="30px"
      >
        Visualizar conteúdo
      </Button>
    </HStack>
  );
};
